module.exports = __webpack_public_path__ + "static/media/edit.20cf3f9e.svg";